/*eslint-disable react/jsx-key */
import React, { Component } from 'react';
import { cloneDeep } from 'lodash';
import { DatePicker } from 'material-ui';
import moment from 'moment';

import Select from '../../Select';
import PeriodField from './PeriodField';
import PaginatedMultiSelect from '../../PaginatedMultiSelect';

import './styles.css';

class FilterType extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // -disable-next-line react/no-unused-state
      internalOptions: cloneDeep(this.props.options),
    };
  }

  _renderPaginatedSelectItem = item => (
    <div key={item.id} style={{ display: 'flex', alignItems: 'center' }}>
      <div
        style={{
          flex: 1,
          marginTop: 4,
          marginBottom: 4,
          color: 'var(--luft-primary)',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '220px',
        }}
        title={item.name}
      >
        {item.name}
      </div>
      <div>
        <input
          type="checkbox"
          checked={
            this.props.value &&
            this.props.value.some(valItem => valItem.id === item.id)
          }
          onChange={() => {
            if (this.props.value === '') {
              this.props.onChange([...this.props.value, item]);
              return;
            }
            if (!this.props.value.some(valItem => valItem.id === item.id)) {
              this.props.onChange([...this.props.value, item]);
              return;
            }
            if (
              this.props.value &&
              this.props.value.some(valItem => valItem.id === item.id)
            ) {
              this.props.onChange(
                this.props.value.filter(valItem => valItem.id !== item.id),
              );
            }
          }}
        />
      </div>
    </div>
  );

  render() {
    const {
      type,
      placeholder,
      onChange,
      value,
      options,
      identifier,
      hasNextPage,
      isNextPageLoading,
      loadNextPage,
      renderLeft,
      searchTerm,
      onSearchByTerm,
      itemSize,
      totalOptions,
      customComponent: CustomComponent,
      customComponentProps,
    } = this.props;

    return (
      <div
        className={
          type === 'paginatedSelect'
            ? 'FilterType__root FilterType__root__paginated'
            : 'FilterType__root'
        }
      >
        {CustomComponent ? (
          <CustomComponent
            value={value}
            onChange={onChange}
            {...customComponentProps}
          />
        ) : (
          <>
            {type && type === 'text' && (
              <input
                placeholder={placeholder}
                className="FilterType__input"
                value={value}
                onChange={event => onChange(event.target.value)}
              />
            )}
            {type && type === 'select' && (
              <Select
                options={options}
                placeholder={placeholder}
                value={value}
                onChange={selectedValue => onChange(selectedValue)}
              />
            )}
            {type && type === 'multiselect' && (
              <div style={{ width: '100%' }}>
                <div style={{ overflowY: 'scroll', maxHeight: '180px' }}>
                  {options &&
                    options.map((option, index) => (
                      <div style={{ display: 'flex', flex: 1, marginBottom: 8 }}>
                        {renderLeft ? renderLeft(index) : null}
                        <div style={{ display: 'flex', flex: 1 }}>
                          {option.name}
                        </div>
                        <input
                          type="checkbox"
                          checked={value.some(val => val.id === option.id)}
                          onChange={() => {
                            if (value.some(val => val.id === option.id)) {
                              onChange(value.filter(val => val.id !== option.id));
                            } else {
                              onChange([...value, option]);
                            }
                          }}
                        />
                      </div>
                    ))}
                </div>
              </div>
            )}
            {type && type === 'paginatedSelect' && (
              <PaginatedMultiSelect
                identifier={identifier}
                placeholder={placeholder}
                options={options}
                hasNextPage={hasNextPage}
                isNextPageLoading={isNextPageLoading}
                loadNextPage={loadNextPage}
                onSearchByTerm={onSearchByTerm}
                value={value}
                searchTerm={searchTerm}
                onChange={onChange}
                itemSize={itemSize}
                totalOptions={totalOptions}
              />
            )}
            {type && type === 'date' && (
              <DatePicker
                selected={moment(this.state.stringValue).toDate()}
                onChange={this._handleChange}
                placeholderText={placeholder}
                inline
                dateFormat="dd/MM/yyyy"
                className="OperationalDashboard__Filter__Dropdowm__DatePicker"
              />
            )}
            {type && type === 'period' && (
              <PeriodField
                onChangeValue={period => {
                  onChange(period);
                }}
                {...value}
              />
            )}
          </>
        )}
      </div>
    );
  }
}

export default FilterType;
